module.exports = __webpack_public_path__ + "static/shoutcart_img2-e46af7fa71e2c27add01d0de0f0bc513.png";